<template>
  <!-- Пример использования -->
  <!-- <Table
        editableColumns         - показ кнопки настроек столбцов
        module                  - модуль, из которого получаем данные (для попапа настроке)
        singleSelect            - одиночный выбор
        @current-change         - cобытие обработки одиночного выбора
        multipleSelect          - множественный выбор 
        @handleSelection        - событие обработки множественного выбора
        canViewValues           - возможность просмотра записи (скачивания файла)
        @handleView             - событие обработки просмотра записи (скачивания файла)
        canDeleteValues         - возможность удаления записи
        @handleDelete           - событие обработки удаления записи 
  /> -->
  <div class="table__wrapper" ref="tableWrapper" v-loading="loadingData">
    <span v-show="noData && emptyText && +heightTable" class="empty">
      <Alert :text="tableData[module].message || emptyText" />
    </span>
    <TableColumnsEditDialog
      v-if="is_visible.table_edit_dialog"
      :is_visible="is_visible.table_edit_dialog"
      :module="tableModule"
      :columnsParams="columnsParams"
      @close-popup="closeDialog('table_edit_dialog')"
      @close-update="closeAndUpdate()"
    />
    <div v-if="+heightTable" style="width: 100%">
      <component :is="'style'">
        .table {min-width: {{ minWidth }}px}
      </component>
      <component v-if="editableColumns" :is="'style'">
        .table-settings {height: {{ settingsPanelHeight }}px}
      </component>
      <el-table
        v-bind="$attrs"
        ref="table"
        :key="updateKey"
        :height="heightTable"
        :data="tableData[module].rows"
        header-cell-class-name="table-header__cell"
        :row-class-name="`table-row ${
          module == MODULE.OMS_CALLS ? 'table-row--noPointer' : ''
        }`"
        cell-class-name="table-row__cell"
        style="width: 100%"
        :highlight-current-row="singleSelect"
        @row-click="
          (row, column) => module != MODULE.OMS_CALLS && rowClick(row, column)
        "
        @current-change="handleSingleChange"
        @selection-change="handleMultiChange"
      >
        <el-table-column
          type="selection"
          v-if="multipleSelect"
        ></el-table-column>
        <el-table-column
          :width="PHOTO_URL ? 52 : 1"
          class-name="avatar-cell"
          :fixed="isColumnFixed('avatar')"
        >
          <template
            slot-scope="scope"
            v-if="PHOTO_URL && module == MODULE.CANDIDATES_MODULE"
          >
            <Avatar
              v-if="scope.row.PHOTO_URL"
              :showTitle="false"
              :url="scope.row.PHOTO ? scope.row.PHOTO_URL : ''"
              :initials="scope.row.PHOTO_PLACEHOLDER || ''"
            />
          </template>
        </el-table-column>
        <el-table-column
          v-for="elem in Object.keys(tableData[module].columns)"
          :key="`${elem}_${updateKey}`"
          :prop="elem"
          :label="tableData[module].columns[elem].lbl"
          show-overflow-tooltip
          :fixed="isColumnFixed(elem)"
          :width="elem == 'candidate_dynamic_name' ? 207 : columnWidth(elem)"
          ref="table_column"
        >
          <template slot="header" v-if="!tableData[module].columns[elem].lbl">
            <Avatar v-if="tableData[module].columns[elem].avatar" />
          </template>

          <template slot-scope="scope">
            <a
              v-if="elem == 'phone'"
              :class="{ 'align-right': isTextAlignRight(elem) }"
              >{{ scope.row[elem.toUpperCase()] }}</a
            >
            <div v-else-if="elem == 'name'" class="table-row__cell--name">
              {{
                scope.row[elem.toUpperCase()]
                  ? formatHtml(scope.row[elem.toUpperCase()])
                  : module == 'HRPAC_VACANCY'
                  ? 'Нет наименования'
                  : 'Нет данных'
              }}
            </div>
            <a
              v-else-if="
                tableFields[elem.toUpperCase()]?.type == 'url' &&
                scope.row[elem.toUpperCase()]
              "
              :href="scope.row[elem.toUpperCase()]"
              target="_blank"
              class="blue fz-15 no-decor"
            >
              {{ scope.row[elem.toUpperCase()] }}
            </a>
            <template
              slot-scope="scope"
              v-else-if="
                (elem == 'candidate_dynamic_name' || elem == 'vacancy_name') &&
                module == MODULE.OMS_CALLS
              "
            >
              <span
                v-if="
                  tableFields[elem.toUpperCase()]?.id_name &&
                  scope.row[
                    tableFields[elem.toUpperCase()]?.id_name.toUpperCase()
                  ]
                "
                class="blue pointer fz-15"
                @click="
                  elem == 'vacancy_name'
                    ? vacancyLink(elem, scope.row)
                    : candidateLink(elem, scope.row)
                "
              >
                {{ scope.row[elem.toUpperCase()] }}
              </span>
              <span
                v-else-if="
                  elem != 'vacancy_name' &&
                  notEmptyPhone(scope.row[elem.toUpperCase()])
                "
                class="table-row__cell--phone"
              >
                {{ scope.row[elem.toUpperCase()] }}
                <Tooltip
                  v-if="scope.row[elem.toUpperCase()]"
                  content="Добавить кандидата"
                >
                  <span
                    class="add-user"
                    @click="createCandidate(scope.row[elem.toUpperCase()])"
                  >
                    <Icon iconName="addUser" />
                  </span>
                </Tooltip>
              </span>
            </template>
            <div v-else-if="elem == 'load_date'" class="table-row__cell--name">
              <Loader v-if="!scope.row[elem.toUpperCase()]" size="small" />
              <p :class="{ 'align-right': isTextAlignRight(elem) }">
                {{
                  formatHtml(scope.row[elem.toUpperCase()])
                    ? formatHtml(scope.row[elem.toUpperCase()])
                    : 'Идет загрузка...'
                }}
              </p>
            </div>
            <InputOnClick
              v-else-if="elem == 'hrpac_vacancy_user_name'"
              :text="formatHtml(scope.row[elem.toUpperCase()])"
              @changeValue="
                value => handleChangeUserText(elem, value, scope.row['ID'])
              "
            />
            <p v-else :class="{ 'align-right': isTextAlignRight(elem) }">
              {{
                formatField(scope.row[elem.toUpperCase()], elem.toUpperCase())
              }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          v-if="canDeleteValues || canViewValues"
          fixed="right"
          v-show="false"
          :width="rowSettingsWidth"
        >
          <template slot-scope="scope">
            <div class="row-options">
              <div class="row-options-buttons">
                <Button
                  v-if="canViewValues"
                  buttonColor="transparent"
                  buttonSize="small"
                  hasLeftIcon
                  iconName="eye"
                  iconColor="#62717E"
                  class="row-options__button"
                  @click="viewRow(scope.$index)"
                />
                <Button
                  v-if="
                    (canDeleteValues && scope.row.id) ||
                    (scope.row.allow_remove === true && scope.row.id)
                  "
                  buttonColor="transparent"
                  buttonSize="small"
                  hasLeftIcon
                  iconName="delete-trash"
                  iconColor="#62717E"
                  class="row-options__button"
                  @click="deleteRow(scope.$index, tableData)"
                />
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="table-loader" ref="table_loader" v-show="requestForMoreIsSent">
      <Loader />
    </div>
    <div
      class="table-loader--fixed"
      ref="fixed-table_loader"
      v-show="requestForMoreIsSent"
    ></div>
    <div
      :class="[
        'table-tooltips',
        PHOTO_URL || multipleSelect ? 'table-tooltips--padding' : ''
      ]"
    >
      <Tooltip
        v-for="elem in Object.keys(tableData[module].columns)"
        :key="`${elem}_${updateKey}`"
        :content="tableData[module].columns[elem].lbl"
        placement="top-start"
        effect="dark"
      >
        <div class="table-tooltips__tooltip"></div>
      </Tooltip>
    </div>
    <div
      class="table-settings"
      v-if="editableColumns && !noData && +heightTable"
    >
      <div class="table-settings__gradient"></div>
      <div class="table-settings__button">
        <Button
          buttonColor="transparent"
          buttonSize="small"
          hasLeftIcon
          iconName="settings"
          iconColor="#62717E"
          @click="handleSettings"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from '@/bus';
import { postController } from '@/controllers/request.js';
import { store } from '@/store';
import { ACTION, EVENTBUS_EVENTS, MODULE } from '@/utils/constants';
import { dialogMixin, mixin } from '@/utils/mixins';
import { Table, TableColumn } from 'element-ui';
import Alert from 'Elements/Alert/Alert';
import TableColumnsEditDialog from 'Elements/Dialog/TableColumnsEditDialog';
import Icon from 'Elements/Icon/Icon';
import Loader from 'Elements/Loader/Loader';
import Tooltip from 'Elements/Tooltip/Tooltip';
import debounce from 'lodash/debounce';
import Avatar from '../Avatar/Avatar';
import Button from '../Button/Button';
import InputOnClick from '../Input/InputOnClick';

export default {
  mixins: [mixin, dialogMixin],
  props: {
    mode: {
      type: String,
      default: ''
    },
    editableColumns: Boolean,
    singleSelect: Boolean,
    multipleSelect: Boolean,
    canDeleteValues: Boolean,
    canViewValues: Boolean,
    fixedColumns: {
      type: Object,
      default: () => {
        return {};
      }
    },
    module: {
      type: String,
      default: ''
    },
    emptyText: {
      type: String,
      default: ''
    }
  },
  created() {
    this.init();

    this.updateFunc = debounce(this.update, 100);
    eventBus.$on(EVENTBUS_EVENTS.UPDATE_TABLE, this.updateFunc);
    eventBus.$on(EVENTBUS_EVENTS.TABLE_SELECTION_CLEAR, this.updateFunc);
    this.initHeaderTooltips();
  },
  beforeDestroy() {
    eventBus.$off(EVENTBUS_EVENTS.UPDATE_TABLE, this.updateFunc);
    eventBus.$off(EVENTBUS_EVENTS.TABLE_SELECTION_CLEAR, this.updateFunc);
  },
  updated() {
    this.init();
    this.initHeaderTooltips();
    debounce(() => this.addScrollListener(), 100)();
  },

  mounted() {
    this.addScrollListener();
  },
  data() {
    return {
      MODULE,
      filters: {},
      minWidth: 0,
      currentRow: null,
      heightTable: '0',
      resizeObserver: null,
      settingsPanelHeight: 0,
      firstLoad: true,
      updateKey: 0,
      headerTooltipsEventsOn: false,
      viewedRows: [],
      markedAfterAjax: [],
      intersectionObserver: null,
      loading: false,
      updateFunc: null
    };
  },
  beforeUnmount() {
    this.resizeObserver.unobserve(this.$refs.tableWrapper);
    if (this.intersectionObserver) {
      document
        .querySelectorAll('.table-row')
        .forEach(el => this.intersectionObserver.unobserve(el));
    }
  },
  watch: {
    multipleSelect() {
      !this.multipleSelect ? this.$refs.table.clearSelection() : null;
    }
  },
  methods: {
    markViewedRows() {
      const formData = new FormData();
      const params = {
        module: MODULE.OMS_CALLS,
        action: 'mark_calls_viewed',
        ids: this.viewedRows,
        to_pdf: 1
      };

      for (let key in params) {
        if (Array.isArray(params[key])) {
          params[key].forEach(element => {
            formData.append(`ids[]`, element);
          });
        } else formData.set(key, params[key]);
      }
      postController({ options: formData })
        .then(resp => {
          if (resp.data.marked && Array.isArray(resp.data.marked)) {
            this.markedAfterAjax = Array.from(
              new Set([...this.markedAfterAjax, ...resp.data.marked])
            );
            this.viewedRows = this.viewedRows.filter(
              r => !resp.data.marked.includes(r)
            );
            this.debouncedHeaderTitle();
          }
        })
        .catch(err =>
          this.catchError(
            err,
            'Возникла ошибка при просмотре пропущенных звонков'
          )
        );
    },
    addRowIds() {
      this.$nextTick(() => {
        if (
          this.module == MODULE.OMS_CALLS &&
          !!document.querySelectorAll('.table-row').length
        ) {
          this.tableData[this.module].rows.forEach((row, i) => {
            const el = document.querySelectorAll('.table-row')[i];
            if (row.VIEWED == '1' && !this.markedAfterAjax.includes(row.ID)) {
              this.markedAfterAjax.push(row.ID);
            }
            if (el && !el?.dataset?.id) {
              el.dataset.id = row.ID;
            }
          });
        }
      });
    },
    addScrollListener() {
      this.resizeObserver = new ResizeObserver(entries => {
        for (const entry of entries) {
          if (entry.target == this.$refs.tableWrapper) {
            this.onResize();
            setTimeout(() => this.addRowIds(), 0);
          } else {
            if (
              (entry.target.scrollHeight <=
                Math.round(
                  entry.target.scrollTop + entry.target.clientHeight
                ) ||
                entry.target.scrollHeight <=
                  Math.round(
                    entry.target.scrollTop + entry.target.clientHeight
                  ) +
                    1) &&
              entry.target.scrollHeight != 0
            ) {
              this.loadMore();
            }
          }
        }
      });
      this.resizeObserver.observe(this.$refs.tableWrapper);

      if (this.module == MODULE.OMS_CALLS) {
        // Создаем новый observer (наблюдатель за видимостью элементов)
        this.intersectionObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(
              function (entry) {
                const viewed = entry.isIntersecting;
                const id = entry.target?.dataset?.id;

                // обрабатываем только видимые элементы, элементы без меток
                if (
                  viewed &&
                  id &&
                  !this.markedAfterAjax.includes(id) &&
                  !this.viewedRows.includes(id)
                ) {
                  this.viewedRows = Array.from(
                    new Set([...this.viewedRows, id])
                  );
                  this.debouncedMarkViewedRows();
                }
              }.bind(this)
            );
          }.bind(this)
        );
      }

      const timer = setTimeout(() => {
        this.minWidth = this.$refs?.table_column
          ? this.$refs?.table_column[0]?.width
          : 100;

        let tableInnerWrapper = document.getElementsByClassName(
          'el-table__body-wrapper'
        );
        let headerCell = document.getElementsByClassName('table-header__cell');
        let tableRows = tableInnerWrapper[0];

        if (tableInnerWrapper?.length) {
          this.resizeObserver.observe(tableInnerWrapper[0]);
        }

        if (this.editableColumns || this.module == MODULE.OMS_CALLS) {
          this.settingsPanelHeight = headerCell
            ? headerCell[0]?.offsetHeight || 45
            : 45;
        }

        if (tableRows) {
          tableRows.addEventListener('scroll', this.loadMoreByScroll);
          if (this.$refs['table_loader']) {
            tableRows.append(this.$refs['table_loader']);
          }
        }

        if (this.intersectionObserver) {
          document
            .querySelectorAll('.table-row')
            .forEach(el => this.intersectionObserver.observe(el));
        }

        const fixedTable = document.getElementsByClassName(
          'el-table__fixed-body-wrapper'
        );
        if (fixedTable.length && this.$refs['fixed-table_loader']) {
          fixedTable[0].append(this.$refs['fixed-table_loader']);
        }

        clearTimeout(timer);
      }, 0);
    },
    //установка тултипов для названий столбцов
    initHeaderTooltips() {
      setTimeout(() => {
        //установка скрола панели с тултипами вместе с основной таблицей
        const tableArea = document.getElementsByClassName(
          'el-table__body-wrapper'
        )[0];
        if (!tableArea) return;
        const popupArea = document.getElementsByClassName('table-tooltips')[0];

        const func = () => {
          popupArea.scroll({ left: tableArea.scrollLeft });
        };
        if (tableArea) {
          tableArea.removeEventListener('scroll', e => func(e));
          tableArea.addEventListener('scroll', e => func(e));
        }

        //установка размеров ячеек для тултипов
        const tooltipHeaderCells = Array.from(
          document.getElementsByClassName('table-tooltips__tooltip')
        );
        const columnCells = Array.from(
          document.getElementsByClassName('table-header__cell')
        );

        const columnCellWithoutAvatar = columnCells.filter(
          elem =>
            !elem.classList.contains('avatar-cell') &&
            !elem.classList.contains('el-table-column--selection')
        );

        for (let i = 0; i < tooltipHeaderCells.length; i++) {
          if (columnCellWithoutAvatar[i]) {
            tooltipHeaderCells[i].style[
              'min-width'
            ] = `${columnCellWithoutAvatar[i].offsetWidth}px`;
          }
        }
      }, 200);
    },
    update() {
      this.updateKey++;
    },
    formatField(fieldValue, fieldName) {
      if (
        this.tableFields[fieldName] &&
        this.tableFields[fieldName].options_array &&
        fieldValue
      ) {
        // Для поле Гражданство и грейд отдаем просто значения
        if (fieldName === 'NATIONALITY' || fieldName === 'GRADE') {
          return fieldValue;
        }

        let newArray = fieldValue.split(',');
        for (let ind = 0; ind < newArray.length; ind++) {
          newArray[ind] =
            this.tableFields[fieldName].options_array[newArray[ind]];
        }
        return newArray.join(', ') || fieldValue;
      } else if (
        fieldName === 'WORK_SITE' &&
        !fieldValue &&
        this.tableFields[fieldName].options_array
      ) {
        return this.tableFields[fieldName].options_array['career'];
      } else {
        return this.formatHtml(fieldValue);
      }
    },
    init() {
      if (this.module == MODULE.CANDIDATES_MODULE) {
        let currentCandidateId = this.$route?.params?.id;
        if (
          this.singleSelect &&
          (this.selectedCandidate || currentCandidateId) &&
          this.$refs?.table
        ) {
          if (this.selectedCandidate) {
            this.$refs.table.setCurrentRow(this.selectedCandidate);
          } else if (currentCandidateId) {
            this.$refs.table.setCurrentRow(
              this.tableData[this.module].rows.find(
                elem => elem?.ID == currentCandidateId
              )
            );
          }
        }
      } else if (this.module == 'vacancy_candidates') {
        let currentVacancyCandidateId = localStorage.getItem(
          'currentVacancyUserId'
        );
        if (
          this.singleSelect &&
          (this.selectedVacancyCandidate || currentVacancyCandidateId) &&
          this.$refs?.table
        ) {
          if (this.selectedVacancyCandidate) {
            this.$refs.table.setCurrentRow(this.selectedVacancyCandidate);
          } else if (currentVacancyCandidateId) {
            this.$refs.table.setCurrentRow(
              this.tableData[this.module].rows.find(
                elem => elem?.ID == currentVacancyCandidateId
              )
            );
          }
        }
      } else if (this.module == 'vacancy_responds') {
        let currentVacancyRespondId = localStorage.getItem(
          'currentVacancyRespondId'
        );
        if (
          this.singleSelect &&
          (this.selectedVacancyRespond || currentVacancyRespondId) &&
          this.$refs?.table
        ) {
          if (this.selectedVacancyRespond) {
            this.$refs.table.setCurrentRow(this.selectedVacancyRespond);
          } else if (currentVacancyRespondId) {
            this.$refs.table.setCurrentRow(
              this.tableData[this.module].rows.find(
                elem => elem?.ID == currentVacancyRespondId
              )
            );
          }
        }
      }
    },
    closeAndUpdate() {
      this.closeDialog('table_edit_dialog');
      if (
        this.module == MODULE.CANDIDATES_MODULE &&
        this.mode != 'Attachment'
      ) {
        store.dispatch('candidate/loadCandidates', { refresh: true });
      } else if (
        this.module == MODULE.CANDIDATES_MODULE &&
        this.mode == 'Attachment'
      ) {
        store.dispatch('candidate/loadCandidates', {
          actionName: 'getListAddCandidatesToVacancy',
          vacancyId: this.$route.params.id,
          attachment: true
        });
      } else if (this.module == MODULE.VACANCY_MODULE) {
        this.mode == 'MassAttachment' || this.mode == 'Attachment'
          ? store.dispatch('vacancy/loadVacanсies', {
              actionName: 'getListAddVacanciesToCandidate',
              candidate_id: this.$route.params.id,
              noFilters: false
            })
          : store.dispatch('vacancy/loadVacanсies', {
              candidate_id: '',
              noFilters: false
            });
      } else if (this.module == 'vacancy_candidates') {
        store.dispatch('candidate/loadCandidates', {
          actionName: 'getCandidatesListInVacancy',
          vacancyId: this.$route.params.id,
          refresh: true
        });
        //TODO: исправить, когда будут доделаны отклики
      } else if (this.module == MODULE.USERS) {
        store.dispatch('users/loadUsers');
      } else if (this.module == 'vacancy_responds') {
        store.dispatch('respond/loadResponds', this.$route.params.id);
      }
    },
    onResize() {
      this.heightTable = this.$refs.tableWrapper?.offsetHeight?.toString();
    },
    async rowClick(row, column) {
      try {
        this.loading = true;
        if (
          this.module != 'vacancy_candidates' &&
          this.mode != 'Attachment' &&
          this.mode != 'MassAttachment' &&
          this.module != 'vacancy_responds' &&
          this.module != MODULE.HRPAC_CANDIDATES_DUPLICATES &&
          column.property != 'hrpac_vacancy_user_name'
        ) {
          this.$router.push(
            `${this.$route.meta.parent}/${this.currentRow?.ID}`
          );
        } else if (this.module === 'vacancy_responds') {
          if (row) {
            store.commit('respond/setParam', {
              name: 'currentVacancyRespond',
              val: row
            });
            localStorage.setItem('currentVacancyRespondId', row?.ID);
            await store.dispatch('respond/getMetadata', this.currentRow?.ID);
          }
        } else if (this.module == MODULE.HRPAC_CANDIDATES_DUPLICATES) {
          this.$router.push(
            `${this.$route.meta.parent}/${this.currentRow?.ID}/compare`
          );
        }
      } finally {
        this.loading = false;
      }
    },
    viewRow(index) {
      this.$emit('handleView', index);
    },
    deleteRow(index, rows) {
      this.$emit('handleDelete', rows[index]);
      // rows.splice(index, 1); // удаляет запись перед подтверждением ???????
    },
    handleChangeUserText(index, value, id) {
      const formData = new FormData();
      const params = {
        module: this.module,
        record: id,
        action: ACTION.SAVE,
        [index]: value,
        jsqon_return: 1
      };

      for (let key in params) {
        formData.set(key, params[key]);
      }

      postController({ options: formData })
        .then(() => {})
        .catch(err =>
          this.catchError(
            err,
            'Возникла ошибка при сохранении пользовательского наименования вакансии',
            'vacancy status saving'
          )
        );
    },
    handleSettings() {
      this.setVisibleDialog(
        'table_edit_dialog',
        !this.is_visible.table_edit_dialog
      );
    },
    handleSingleChange(val) {
      this.currentRow = val;
      if (this.module == MODULE.CANDIDATES_MODULE) {
        store.commit('candidate/setParam', {
          name: 'currentCandidate',
          val
        });
        if (val) localStorage.setItem('currentUserId', val?.ID);
      } else if (this.module == 'vacancy_candidates') {
        if (val) {
          localStorage.setItem('currentVacancyUserId', val?.ID);
          store.dispatch('candidate/getMetadata', {
            id: this.currentRow?.ID,
            shouldRequestRightPanel: false
          });
          //в случае если открыта правая панель, обновляем метаданные
          if (store.state.rightPanel.panelMode) {
            this.updateRightPanelData(val?.ID);
          }
        }
        store.commit('vacancy/setParam', {
          name: 'currentVacancyCandidate',
          val
        });
      } else if (this.module == MODULE.USERS) {
        store.commit('users/setParam', {
          name: 'currentUser',
          val
        });
      }
      this.$emit('handleSingleSelection', val);
    },
    handleMultiChange(val) {
      this.$emit('handleMultiSelection', val);
    },
    isColumnFixed(columnName) {
      let columns = Object.keys(this.fixedColumns);
      return columns.includes(columnName)
        ? this.fixedColumns[columnName]
        : false;
    },
    isTextAlignRight(columnName) {
      return this.tableData[this.module].columns[columnName]?.align == 'right';
    },
    columnWidth(columnName) {
      switch (columnName) {
        case 'name':
        case 'name_id':
        case 'last_work':
          return 300;
        case 'main_phone':
          return 170;
        case 'main_email':
          return 210;
        default:
          return 140;
      }
    },
    loadMore() {
      if (!this.requestForMoreIsSent) {
        const offset =
          store.state.selectionPopup.popupPageConfig?.offsets?.next;
        if (!offset || offset == -1) return;
        //скрол к концу списка для показа лоадера
        let tableRows = document.getElementsByClassName(
          'el-table__body-wrapper'
        )[0];
        tableRows.scrollBy({
          top: tableRows?.offsetHeight,
          behavior: 'smooth'
        });

        let filters = {};
        for (let key in this.dataFilters) {
          if (
            this.dataFilters[key].value != null &&
            this.dataFilters[key].value != false
          ) {
            filters[key] = this.dataFilters[key].value;
          }
        }

        const params = {
          ...store.state.selectionPopup?.baseParams,
          ...filters
        };

        if (this.dataSortParams?.orderBy) {
          params['orderBy'] = this.dataSortParams.orderBy;
        }
        if (this.dataSortParams?.sortOrder) {
          params['sortOrder'] = this.dataSortParams.sortOrder;
        }

        if (
          this.module == 'vacancy_candidates' ||
          (this.module == MODULE.CANDIDATES_MODULE && this.mode == 'Attachment')
        ) {
          params['vacancy_id'] = this.$route.params.id;
          params['displayMode'] = 'spa';
          params['action'] =
            this.module == 'vacancy_candidates'
              ? 'getCandidatesListInVacancy'
              : 'getListAddCandidatesToVacancy';
        }

        if (this.module == MODULE.VACANCY_MODULE) {
          switch (this.mode) {
            case 'Attachment':
              params['candidate_id'] = this.$route.params.id;
              params['displayMode'] = 'spa';
              params['action'] = 'getListAddVacanciesToCandidate';
              break;
            case 'MassAttachment':
              params['displayMode'] = 'spa';
              params['selected_ids'] =
                store.state.attachment.massAttachCandidates;
              break;
            default:
              break;
          }
        }

        if (this.module == 'vacancy_responds') {
          params['vacancy_id'] = this.$route.params.id;
        }

        //установка параметра для пагинации
        switch (this.module) {
          case MODULE.CANDIDATES_MODULE:
          case 'vacancy_candidates':
            //для случая подгрузки кандидатов вакансии
            params['HRPAC_CANDIDATES2_HRPAC_CANDIDATES_offset'] = offset;
            break;
          case MODULE.VACANCY_MODULE:
            params['HRPAC_VACANCY2_HRPAC_VACANCY_offset'] = offset;
            break;
          case MODULE.OMS_CALLS:
            params['OMS_CALLS2_OMS_CALLS_offset'] = offset;
            break;
          case 'vacancy_responds':
            params[
              'HRPAC_CANDIDATE_RESPONDS2_HRPAC_CANDIDATE_RESPONDS_offset'
            ] = offset;
            break;
          case MODULE.HRPAC_CANDIDATES_DUPLICATES:
            params[
              'HRPAC_CANDIDATES_DUPLICATES2_HRPAC_CANDIDATES_DUPLICATES_offset'
            ] = offset;
            break;
          case MODULE.USERS:
            params['Users2_USER_offset'] = offset;
            break;
          default:
            throw new Error('Нет параметра пагинации для данной таблицы!');
        }

        this.loadPopupData(params);
      }
    },
    loadMoreByScroll(e) {
      if (
        (e.target.scrollHeight <=
          Math.round(e.target.scrollTop + e.target.clientHeight) ||
          e.target.scrollHeight <=
            Math.round(e.target.scrollTop + e.target.clientHeight) + 1) &&
        !this.requestForMoreIsSent
      ) {
        debounce(() => this.loadMore(), 100)();
      }
    },
    async loadPopupData(params, replace = false) {
      this.loading = true;
      try {
        await store.dispatch('selectionPopup/loadPopupData', {
          params,
          replace
        });
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
        this.requestSent = false;
      }
    },
    clearCurrentRow() {
      this.currentRow = null;
    },
    updateRightPanelData(id) {
      const params = {
        action: 'get_RightPanel',
        module: 'HRPAC_SELECTION_STAGE_CANDIDATES_1',
        vacancy_id: this.$route.params.id,
        candidate_id: id,
        content_type:
          store.state.rightPanel?.metadata?.type &&
          store.state.rightPanel?.metadata?.type == 'vac_card_selcand'
            ? 'vac_card_selcand'
            : 'vac_card_selvac'
      };
      let stages = store.state.rightPanel?.metadata?.content?.data;
      if (stages) {
        params['hidden_stage_ids'] = stages
          .filter(stage => !stage.state)
          .map(stage => stage.id);
      }
      store.dispatch('rightPanel/getMetadata', { intentOrRequest: params });
    },
    candidateLink(elem, row) {
      if (!this.tableFields[elem.toUpperCase()].id_name) return;
      const field = this.tableFields[elem.toUpperCase()].id_name.toUpperCase();
      const id = row[field];
      this.$router.push(`/candidates/${id}`);
    },
    vacancyLink(elem, row) {
      if (!this.tableFields[elem.toUpperCase()].id_name) return;
      const field = this.tableFields[elem.toUpperCase()].id_name.toUpperCase();
      const id = row[field];
      this.$router.push(`/vacancies/${id}`);
    },
    notEmptyPhone(phone) {
      return phone.replace(/,|\(|\)|\.|-|\+|e|\s/g, '');
    },
    createCandidate(phone) {
      if (!phone) return;
      this.$router.push(
        `/candidates/edit?prefill_phone=${this.notEmptyPhone(phone)}`
      );
    }
  },
  computed: {
    loadingData() {
      switch (this.module) {
        case MODULE.CANDIDATES_MODULE:
        case 'vacancy_candidates':
          return (
            store.state.candidate.loading || store.state.candidate.requestSent
          );
        case MODULE.USERS:
          return store.state.users.loading;
        case 'vacancy_responds':
          return store.state.candidate.respondOpening;
        default:
          return false;
      }
    },
    columnsParams() {
      return this.module == MODULE.CANDIDATES_MODULE ||
        this.module == 'vacancy_candidates'
        ? store.state.candidate.tableTitleParams
        : this.module == MODULE.VACANCY_MODULE
        ? store.state.vacancy.tableTitleParams
        : this.module == 'vacancy_responds'
        ? store.state.respond.tableTitleParams
        : null;
    },
    PHOTO_URL() {
      return (
        !this.multipleSelect && this.tableData[this.module].rows[0]?.PHOTO_URL
      );
    },
    tableModule() {
      return this.module == 'vacancy_candidates'
        ? MODULE.CANDIDATES_MODULE
        : this.module == 'vacancy_responds'
        ? 'HRPAC_CANDIDATE_RESPONDS'
        : this.module;
    },
    selectedCandidate() {
      if (this.$refs?.table) {
        store.state.candidate.currentCandidate
          ? this.$refs?.table.setCurrentRow(
              store.state.candidate.currentCandidate
            )
          : this.$refs.table.setCurrentRow();
      }
      if (!store.state.candidate.currentCandidate) {
        this.clearCurrentRow();
      }

      return store.state.candidate.currentCandidate;
    },
    selectedVacancyCandidate() {
      if (this.$refs?.table) {
        store.state.vacancy.currentVacancyCandidate
          ? this.$refs?.table.setCurrentRow(
              store.state.vacancy.currentVacancyCandidate
            )
          : this.$refs.table.setCurrentRow();
      }
      if (!store.state.vacancy.currentVacancyCandidate) {
        this.clearCurrentRow();
      }

      return store.state.vacancy.currentVacancyCandidate;
    },
    selectedVacancyRespond() {
      if (this.$refs?.table) {
        store.state.respond.currentVacancyRespond
          ? this.$refs?.table.setCurrentRow(
              store.state.respond.currentVacancyRespond
            )
          : this.$refs.table.setCurrentRow();
      }
      if (!store.state.respond.currentVacancyRespond) {
        this.clearCurrentRow();
      }

      return store.state.respond.currentVacancyRespond;
    },
    noData() {
      return !store.state.common.tableData[this.module]?.rows.length || false;
    },
    requestForMoreIsSent() {
      return store.state.selectionPopup.requestSent;
    },
    debouncedMarkViewedRows() {
      return debounce(this.markViewedRows, 500);
    },
    debouncedHeaderTitle() {
      return debounce(() => store.dispatch('calls/checkForUnviewedCalls'), 500);
    },
    rowSettingsWidth() {
      return this.canViewValues && this.canDeleteValues ? 72 : 40;
    },
    multipleSelection() {
      return store.state.candidate.changeableList.list;
    },
    is_visible() {
      return store.state.common.visible_dialog;
    },
    tableFields() {
      return store.state.common.tableFields || null;
    },
    tableData() {
      return store.state.common.tableData || null;
    },
    dataFilters() {
      return store.state.filters?.filterConfig?.custom_filters &&
        store.state.filters?.filterConfig?.filters
        ? {
            ...store.state.filters.filterConfig.custom_filters,
            ...store.state.filters.filterConfig.filters
          }
        : store.state.filters?.filterConfig?.filters
        ? store.state.filters?.filterConfig.filters
        : null;
    },
    dataSortParams() {
      return store.state.filters.filterConfig.sortable;
    }
  },
  components: {
    'el-table': Table,
    'el-table-column': TableColumn,
    Button,
    Avatar,
    InputOnClick,
    Loader,
    TableColumnsEditDialog,
    Alert,
    Icon,
    Tooltip
  }
};
</script>

<style lang="scss" scoped>
.table {
  &__wrapper {
    display: flex;
    height: 100vh;
    position: relative;
    width: inherit;

    .empty {
      position: absolute;
      width: 100%;
      padding: 65px 16px 16px;
      z-index: 2;
    }

    & ::v-deep .el-table__header-wrapper,
    & ::v-deep .el-table__body-wrapper {
      table {
        width: 100% !important;
      }
    }
  }

  &-settings {
    padding: 12px 0;
    background-color: transparent;
    display: flex;
    position: absolute;
    top: 0;
    right: 0;
    width: 64px;
    justify-content: center;
    z-index: 1000;

    &__button {
      display: flex;
      align-items: center;
      padding-right: 15px;
      background: $white;
    }

    &__gradient {
      width: 24px;
      background: linear-gradient(
        270deg,
        #ffffff 0%,
        rgba(255, 255, 255, 0) 100%
      );
    }
  }

  &-loader,
  &-loader--fixed {
    height: 60px;
  }

  &-loader {
    display: flex;
    align-items: center;
    justify-content: center;
    position: sticky;
    left: 0;
  }

  &-tooltips {
    display: flex;
    position: absolute;
    height: 48px;
    max-width: 100%;
    background-color: transparent;
    overflow-x: hidden;

    &--padding {
      padding-left: 52px;
    }
  }
}

.el-table {
  width: 100%;
  border: 1px solid $grey8;
  border-radius: 4px;

  & ::v-deep .el-table__empty-block {
    display: none;
  }

  &.el-table--scrollable-x {
    border-bottom: none;
  }

  & ::v-deep .table {
    &-header {
      &__cell {
        color: $grey64;
        max-height: 57px;

        & > .cell {
          line-height: 20px;
          white-space: nowrap;
        }

        &:first-of-type {
          padding: 14px 0;

          & > .cell {
            padding: 0px 8px 0px 16px;
          }
        }

        &:not(:first-of-type) {
          & > .cell {
            padding: 0px 12px;
          }
        }
      }
    }

    &-row {
      cursor: pointer;

      &--noPointer,
      &--noPointer .table-row__cell,
      &--noPointer .table-row__cell .cell,
      &--noPointer .table-row__cell .cell p {
        cursor: default;
      }

      &:hover {
        & > .table-row__cell {
          background-color: $blue8 !important;
        }
      }

      .avatar-cell {
        padding: 8px 0 !important;

        & ::v-deep .avatar {
          width: 32px;
        }
      }

      &__cell {
        color: $grey64;

        .cell {
          color: $grey80;
          font-size: 15px;
          line-height: 24px;
          position: relative;
          cursor: pointer;

          p {
            cursor: pointer;
          }
        }

        &--name {
          display: flex;
          gap: 8px;
          align-items: center;
          cursor: pointer;

          a {
            text-decoration: none;
          }
        }

        &--user-text {
          display: flex;
          align-items: center;

          svg {
            min-width: 16px;
            width: 16px;
            height: 16px;
          }
        }

        &--phone {
          .add-user {
            position: absolute;
            right: 4px;
            cursor: pointer;
          }
        }

        p {
          overflow: hidden;
          text-overflow: ellipsis;
        }

        &:first-of-type {
          padding: 12px 0;

          & > .cell {
            padding: 0px 8px 0px 16px;
          }
        }

        &:not(:first-of-type) {
          & > .cell {
            padding: 0px 8px;
          }
        }
      }
    }
  }

  & ::v-deep .el-checkbox {
    & > .is-indeterminate {
      & > .el-checkbox__inner {
        background-image: url('../../../assets/img/checkbox-indeterminate.svg') !important;
        width: 20px;
        height: 20px;
        border: none;
      }

      &::after {
        content: none;
      }
    }

    & > .is-checked {
      & > .el-checkbox__inner {
        background-image: url('../../../assets/img/checkbox-checked_blue.svg') !important;
        width: 20px;
        height: 20px;
        border: none;

        &::after {
          content: none;
        }
      }
    }

    & .el-checkbox__inner {
      background-image: url('../../../assets/img/checkbox_square.svg') !important;
      width: 20px;
      height: 20px;
      border: none;
      background-color: transparent;

      &::after {
        content: none;
      }

      &::before {
        display: none;
      }
    }
  }
}

.row-options {
  display: flex;

  &-buttons {
    display: flex;
    gap: 8px;
  }

  &__button {
    width: 24px;
    height: 24px;
    margin: 0 !important;
    background-color: transparent !important;

    &:focus {
      outline: none;
    }
  }
}

.el-button {
  display: flex;
  justify-self: center;
  background-color: $white;

  & ::v-deep .button-content {
    margin: 0 !important;
  }
}

.align-right {
  text-align: right;
}

.header-tooltip {
  height: 100%;
}
</style>
